import { foregroundOn, initialOf } from "../tokens/palette.js";
import type { EventPerson } from "../lib/types.js";

/**
 * The coloured discs that say who an event belongs to.
 *
 * The initial sits inside the disc rather than beside it, so the colour and the
 * name are one object at a glance — which is the whole point of the system.
 */
export function PersonDiscs({
  people,
  size = 17,
  muted = false,
}: {
  people: EventPerson[];
  size?: number;
  muted?: boolean;
}): React.JSX.Element {
  return (
    <span className="discs" style={{ gap: Math.round(size * 0.28) }}>
      {people.map((person) => (
        <span
          key={person.id}
          className="disc"
          title={person.display_name}
          style={{
            width: size,
            height: size,
            background: person.color,
            color: foregroundOn(person.color),
            fontSize: Math.round(size * 0.56),
            lineHeight: `${String(size)}px`,
            opacity: muted ? 0.45 : 1,
          }}
        >
          {initialOf(person.display_name)}
        </span>
      ))}
    </span>
  );
}
